import { usePublicAccountsDispatch } from './public-accounts-context';
import PortalAppService from '../../../application/platform/portal-app-service';
import { IListPublicAccountRequest } from '../../../model/base/request/list-public-account-request';

export function usePublicAccountsController() {
  const dispatch = usePublicAccountsDispatch();

  const loadData = async (params: IListPublicAccountRequest) => {
    dispatch({ type: 'LOAD_START' });

    try {
      const response = await PortalAppService.listPublicAccount(params);
      dispatch({ type: 'LOAD_SUCCESS', payload: response });
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || 'Erro ao carregar contas públicas';
      dispatch({ type: 'LOAD_ERROR', payload: errorMessage });
    }
  };

  const loadCategories = async () => {
    dispatch({ type: 'LOAD_CATEGORIES_START' });

    try {
      const response = await PortalAppService.listCategoriesWithSubcategories();
      dispatch({ type: 'LOAD_CATEGORIES_SUCCESS', payload: response });
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || 'Erro ao carregar categorias';
      dispatch({ type: 'LOAD_CATEGORIES_ERROR', payload: errorMessage });
    }
  };

  return {
    loadData,
    loadCategories,
  };
}
